import React, { type ReactElement, type ReactNode } from 'react';
import Link from 'next/link';
import { Button as AntButton, type ButtonProps as AntButtonProps } from 'antd';
import classNames from 'classnames';

export interface ButtonProps extends Omit<AntButtonProps, 'type'> {
  type?:
    | 'primary'
    | 'tonal'
    | 'outline'
    | 'link'
    | 'black'
    | 'cart'
    | 'gray'
    | 'danger-outline'
    | 'filterTag';
  children?: ReactNode;
  fixed?: boolean;
  link?: string;
  linkScroll?: boolean;
}

interface LinkComponentProps {
  link?: string;
  scroll?: boolean;
  children: ReactNode;
}

const LinkComponent = ({ link, scroll, children }: LinkComponentProps) => {
  if (link) {
    return (
      <Link href={link} scroll={scroll}>
        {children}
      </Link>
    );
  }
  return <>{children}</>;
};

export default function Button({
  children,
  type,
  className,
  fixed,
  link,
  linkScroll,
  ...rest
}: ButtonProps): ReactElement {
  return (
    <LinkComponent link={link} scroll={linkScroll}>
      <AntButton
        rootClassName="button"
        className={classNames(
          'z-50 h-11 rounded-md text-xs font-medium',
          {
            'primaryBtn bg-blue-default text-white':
              type === 'primary' || !type,
          },
          {
            'blackBtn bg-black-default text-white': type === 'black' || !type,
          },
          {
            ' cart-btn bg-silver-200 text-secondary-default':
              type === 'cart' || !type,
          },
          { 'tonalBtn bg-silver-300 text-black-default': type === 'tonal' },
          {
            'border-1 outlineBtn border-blue-default bg-transparent text-blue-default':
              type === 'outline',
          },
          {
            'border-1 outlineDangerBtn border-red-default bg-transparent text-blue-default':
              type === 'danger-outline',
          },
          {
            'linkBtn h-auto rounded-sm bg-transparent p-0 text-blue-default':
              type === 'link',
          },
          {
            'rounded-lg bg-silver-200 px-4 py-2  font-semibold text-secondary-400':
              type === 'gray',
          },
          {
            'rounded-[10px] border border-[#EDECEB] bg-[#F2F1F1] px-4 py-2 text-sm font-medium !text-black-default hover:!border-solid hover:!text-black-default lg:rounded-[10px]':
              type === 'filterTag',
          },

          [fixed && 'fixed bottom-6 right-4 !w-[calc(100%_-_32px)] '],
          className
        )}
        {...rest}
      >
        {children}
      </AntButton>
    </LinkComponent>
  );
}
